import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Chart } from 'chart.js/auto';
import { Subscription } from 'rxjs';
import { ReviewerChartViewModel } from '../../requests/Model/reviewerChartViewModel';
import { RequestService } from '../../requests/services/requests.services';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.css']
})
export class GraphComponent {
  @ViewChild('reviewerchart') chartElementRef!: ElementRef;
  @Input() requestId: number | undefined;
  @Input() reviewerName: string | undefined;
  isChartLoading = false;
  chartSubscription?: Subscription;
  chart: any = [];
  reviewerChartViewModel?: ReviewerChartViewModel;
  ctx: any;

  constructor(private readonly requestService: RequestService) {
  }

  ngOnDestroy(): void {
    this.chartSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.ctx = this.chartElementRef.nativeElement.getContext('2d');
    this.getReviewerChartData(Number(this.requestId), String(this.reviewerName));
  }

  getReviewerChartData(id: number, name: string) {
    this.isChartLoading = true;
    this.chartSubscription = this.requestService.getReviewerChart(id, name).subscribe({
      next: (response: any) => {
        this.reviewerChartViewModel = response;
      },
      error: (error: any) => {
        this.reviewerChartViewModel = undefined;
        console.log(error)
      },
      complete: () => {
        this.isChartLoading = false;
        this.setReviewerChartData(this.ctx, name, this.reviewerChartViewModel);
      }
    });
  }

  setReviewerChartData(ctx: any, reviewerName: string, chartViewModel?: ReviewerChartViewModel) {
    if (chartViewModel === undefined) {
      this.chart = null;
    }
    else {
      var dataForChart = [];
      for (var val of chartViewModel.responseCountForApps) {
        dataForChart.push({
          label: val.response,
          backgroundColor: this.getChartBackgroundColor(val.response),
          data: val.countArray
        });
      }

      const stackeddata = {
        labels: chartViewModel.impactedApplications,
        datasets: dataForChart
      };
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: stackeddata,
        options: {
          plugins: {
            title: {
              display: true,
              text: reviewerName + ' response statistics'
            },
          },
          responsive: false,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true
            }
          }
        }
      });

    }

  }

  getChartBackgroundColor(response: string) {
    switch (response) {
      case ("Approved"):
        return "#5cb85c";
        break;
      case ("Accepted"):
        return "#76b55b";
        break;
      case ("Needs more work"):
      case ("Rejected"):
        return "#d9534f";
        break;
      case ("Not Relevant"):
        return "#D0E4B0";
        break;
      case ("Could Not Test"):
        return "#f0ad4e";
        break;
      case ("Requested"):
        return "#909090";
        break;
      case ("Closed"):
        return "#5bc0de";
        break;
      default:
        return "#909090";
    }
  }
}
